import React from 'react';
import _ from 'lodash';
import $ from 'jquery';

import Disciplines from './disciplines/disciplinesComponent';
import Filter from './filter/filterComponent';
import Lightbox from './units/lightboxComponent';

import {
  decodeHtmlData,
  hasClassification,
  hasEnoughUnits,
  hasTerm,
  hasDisciplines,
  divDisciplines,
  filterDisciplines } from './../mixin/mixin';

import reducer from './../reducer/reducer';

import {
  $setFilterContentHeight,
  $setEqualHeight,
  $fetchData
} from './../mixin/mixin-jquery';

class App extends React.Component {
  constructor(props) {
    super();

    // To decode rawhtmlencoded data (matrix modifier)
    this._decodeHtmlData = decodeHtmlData;

    // for matching
    this._hasClassification = hasClassification;
    this._hasEnoughUnits = hasEnoughUnits;
    this._hasTerm = hasTerm;
    this._hasDisciplines = hasDisciplines;

    // for filtering
    this._divDisciplines = divDisciplines;
    this._filterDisciplines = filterDisciplines.bind(this);

    // for styling/ajax
    this._$setFilterContentHeight = $setFilterContentHeight;
    this._$setEqualHeight = $setEqualHeight;
    this._$fetchData = $fetchData;

    // for comparison
    this._doComparison = this._doComparison.bind(this);

    // reducer
    this._reducer = reducer.bind(this);

    // pass to children and change state purpose
    this.dispatchReducer = this.dispatchReducer.bind(this);

    this.state = {
      data:               props.data || {},
      options:            props.options || {},
      disciplines:        props.data.disciplines,
      degrees:            props.data.degrees,
      currClassification: 'Critical Content',
      currDisciplines:    [],
      currDiscipline:     '',
      term:               '',
      result:             {},
      count:              0,
      initLoad:           true,
      showLightbox:       false,
      hideFilters:        true,
      currDegree:         {},
      currUnits:          {},
      placeholderText:    'Enter a discipline',
      searchResultName:   'Disciplines',
      lightboxType:       'Disciplines',
      comparedUnits:      []
    };

    // do the first filter
    let options = {
      currClassification: this.state.currClassification
    }
    this.state.result = this._divDisciplines( this.state.disciplines );
  }

  componentDidMount() {
    // read localStorage
    this.dispatchReducer({type: 'UNIT_COMPARE::INIT'});

    /* 1.Do Styling - jQuery */

    // set filter content height
    this._$setFilterContentHeight();

    // set main container height = left nav height + right column height
    this._$setEqualHeight();

    /* 2.Bind events to window resize - jQuery */
    $(window).on('resize', () => {
      // set filter content height
      this._$setFilterContentHeight();

      // set main container height = left nav height + right column height
      this._$setEqualHeight();
    });

    if (localStorage) {
      localStorage.removeItem('last_visited_path');
    }
  }

  render() {
    var disciplines = this.state.disciplines || [],
        result = this.state.result;

    return <div id="AppByDiscipline_content" className="application appByDiscipline">
      <div className="app-sub-nav-wrapper units-by-discipline desktop-only">

        <div className="sq-form-control clearfix hidden">
          <input type="Submit"
                 name="compare_units_submit"
                 value="View My Shortlist"
                 disabled={this.state.comparedUnits.length < 1}
                 className={this.state.comparedUnits.length >= 1 ?
                   'button type-2 btn-submit btn-submit-compare btn btn--full-width' : 'button type-2 btn-submit btn-submit-compare btn btn--full-width is-disabled'}
                 onClick={this._doComparison} />
        </div>

        <div className="widget unit-filter"></div>
      </div>

      <div className="main-content">
        <div className="content">

          <div className="asset-content"
               dangerouslySetInnerHTML={{__html: this._decodeHtmlData(this.state.options.page_description)}} />

             <div className="sq-form-control clearfix mobile-only hidden">
            <input type="Submit"
                   name="compare_units_submit"
                   value="View My Shortlist"
                   disabled={this.state.comparedUnits.length < 1}
                   className={this.state.comparedUnits.length >= 1 ?
                     'button type-2 btn-submit btn-submit-compare btn btn--full-width' : 'button type-2 btn-submit btn-submit-compare btn btn--full-width is-disabled'}
                   onClick={this._doComparison} />
          </div>

          <Disciplines data={result}
                   dispatchReducer={this.dispatchReducer} />

        </div>
      </div>

      { this.state.showLightbox ? <Lightbox data={this.state.currUnits}
                                            heading={this.state.currDiscipline.label}
                                            currClassification={this.state.currClassification}
                                            options={this.state.options}
                                            hideFilters={this.state.hideFilters}
                                            dispatchReducer={this.dispatchReducer}
                                            lightboxType = {this.state.lightboxType}
                                            comparedUnits={this.state.comparedUnits} /> : null }
    </div>;
  }

  _doComparison(e) {
    e.preventDefault();
    console.log(this.state.options);
    window.location = this.state.options.url_compare;
  }

  /* dipatch changes based on actions
   *
   * ACTION Types are 'DISC::ADD', 'DISC::REMOVE', 'ALL::RESET', 'TERM::CHANGE'
   *
   * @param [object] action {type [, value]}
   *
   * @no return [change state] currDisciplines
   */
  dispatchReducer(action) {
    let newState = _.merge({}, this.state);

    if (_.isArray(action)) {
      for (let i = 0, len = action.length; i < len; i++) {
        newState = this._reducer(newState, action[i]);
      }

    } else {
      newState = this._reducer(newState, action);
    }

    if (action.fireFilter) {
      const options = {
        disciplines: newState.disciplines,
        term:        newState.term
      };

      newState = this._reducer(newState, {
        type: 'INIT::REMOVE'
      });

      newState = this._reducer(newState, {
        type:  'RESULT_DISC::UPDATE',
        value: options
      });

      newState = this._reducer(newState, {
        type: 'RESULT_DISC::DIV'
      });

      newState = this._reducer(newState, {
        type: 'COUNT_DISC::UPDATE'
      });
    }

    this.setState(newState);
  }
}

App.propTypes = {
  data:    React.PropTypes.object.isRequired,
  options: React.PropTypes.object
};

export default App;
